import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {onCaptchaResponse, onForgotPassword} from '../actions/AccountActions';
import ForgotPassword from '../components/ForgotPassword';

@connect(state => ({...state.captcha}), {onCaptchaResponse, onSubmit: onForgotPassword})
export default class ForgotPasswordContainer extends Component {
    static propTypes = {
        captchaResponse: PropTypes.string,
        onSubmit: PropTypes.func,
        onCaptchaResponse: PropTypes.func,
        location: PropTypes.object,
        history: PropTypes.object,
    };

    handleSubmit = (data) => {
        const {history, captchaResponse} = this.props;
        this.props.onSubmit({...data, captchaResponse}, history);
    };

    render() {
        return (
            <div className="page">
                <div className="page_contents">
                    <h1>{'Register for an account'}</h1>
                    <div className="card" style={{minHeight: 600}}>
                        <ForgotPassword
                            {...this.props}
                            onSubmit={this.handleSubmit}
                        />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordContainer.js